"use client";

import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { motion } from "framer-motion";
// import type { TurnstileInstance } from "@marsidev/react-turnstile"; // کامنت شد
import { RefreshCw, Loader2 } from "lucide-react";

import OtpInput from "@/components/OtpInput";
import { Spinner, FADE_IN_VARIANTS, buttonClasses } from "./ui";
import { FormData } from "./schemas";

type VerificationStepProps = {
    onFormSubmit: (data: FormData) => void;
    onResend: (token: string) => void; // پراپ onResend اضافه شد
    isLoading: boolean;
    isResending: boolean;
    timer: number;
    isTimerActive: boolean;
    // turnstileRef: React.RefObject<TurnstileInstance>; // کامنت شد
};

export const VerificationStep: React.FC<VerificationStepProps> = ({ onFormSubmit, onResend, isLoading, isResending, timer, isTimerActive }) => {
    const { control, handleSubmit, getValues, formState: { errors } } = useFormContext<FormData>();

    const formatTime = (timeInSeconds: number) => {
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = timeInSeconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const handleResendClick = () => {
        console.log("VerificationStep: handleResendClick called. Calling onResend with placeholder token.");
        if (isResending) return;
        // turnstileRef.current?.reset(); // کامنت شد
        onResend("dev-placeholder-token"); // ✅ مستقیماً onResend را با توکن موقت فراخوانی می‌کنیم
    };

    return (
        <motion.div key="verify-step" variants={FADE_IN_VARIANTS} initial="hidden" animate="visible" exit="exit" className="flex flex-col items-center">
            <div className="text-center text-zinc-500 dark:text-zinc-400 mb-6 leading-relaxed">
                <p>یک کد ۶ رقمی به</p>
                <p className="font-bold text-zinc-900 dark:text-zinc-100 mt-1 ltr">{getValues("identifier")}</p>
                <p>ارسال شد. لطفاً آن را وارد کنید.</p>
            </div>
            <form onSubmit={handleSubmit(onFormSubmit)} className="space-y-6 w-full flex flex-col items-center">
                <Controller name="otp_code" control={control} render={({ field }) => (
                    <div className="flex flex-col items-center gap-2">
                        <label className="text-sm font-medium text-zinc-700 dark:text-zinc-300">کد تایید</label>
                        <OtpInput length={6} onComplete={(otp) => {
                            field.onChange(otp);
                            setTimeout(() => handleSubmit(onFormSubmit)(), 100);
                        }} />
                        {errors.otp_code && <p className="text-tiny text-red-500 mt-1">{errors.otp_code.message}</p>}
                    </div>
                )} />
                <motion.button whileTap={{ scale: 0.98 }} type="submit" disabled={isLoading} className={buttonClasses}>
                    {isLoading ? <Spinner /> : null}
                    {isLoading ? "در حال تأیید..." : 'تأیید و ایجاد حساب'}
                </motion.button>
            </form>
            <div className="mt-6 text-center text-sm h-5">
                {isTimerActive && timer > 0 ? (
                    <p className="text-zinc-500 dark:text-zinc-400">ارسال مجدد کد تا {formatTime(timer)} دیگر</p>
                ) : (
                    <button type="button" onClick={handleResendClick} disabled={isResending} className="inline-flex items-center gap-2 font-semibold text-blue-600 hover:text-blue-800 dark:hover:text-blue-400 disabled:opacity-60 disabled:cursor-not-allowed transition-colors">
                        {isResending ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />}
                        {isResending ? "در حال ارسال..." : "ارسال مجدد کد"}
                    </button>
                )}
            </div>
        </motion.div>
    );
};
